import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getScheduledJobDetailSlice = createApi('GetScheduledJobDetailSlice', 'GET');

const GetScheduledJobDetailSlice = createSlice({
  name: 'GetScheduledJobDetailSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getScheduledJobDetailSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getScheduledJobDetailSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getScheduledJobDetailSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default GetScheduledJobDetailSlice.reducer;
